/* eslint-disable no-useless-catch */
import { OrderItem } from '../../interfaces/Order';

export const mapSaferHomeNames = (orderItems: OrderItem[]) => {
  return orderItems
    .map((orderItem) => orderItem.salesItem.localisedCommunications?.[0].productName)
    .filter(Boolean)
    .join(', ');
};

/**
 * Loads `esiSaferHomesProductList` object from window if it exists
 */
export const loadSaferHomesProductList = async () => {
  if (typeof window.esiSaferHomesProductList === 'object') {
    return Object.keys(window.esiSaferHomesProductList);
  }
  try {
    const saferHomesProductList: string[] = await fetch(
      window.payorder.SAFER_HOMES_PRODUCT_LIST_URL,
    )
      .then((response) => response.json())
      .then((data) => Object.keys(data));
    return saferHomesProductList;
  } catch (error) {
    throw error;
  }
};

export const filterSaferHomesProducts = (
  orderItems: OrderItem[],
  saferHomesProductList: string[],
) => orderItems.filter((orderItem) => saferHomesProductList.includes(orderItem.orderLine.itemNo));
